import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const SmsIcon: FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props}>
    <path d="M16.001 14.04a2 2 0 0 1 1.249-.437H28V4H15v10.841l1.001-.8ZM15 17.402l-.08.065-.62.494-.488.39a.5.5 0 0 1-.812-.39V4a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v9.603a2 2 0 0 1-2 2H17.25L15 17.401ZM9 7a1 1 0 0 0-1 1v19a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-9.5a1 1 0 1 1 2 0V27a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h1.25a1 1 0 1 1 0 2H9Zm4 18a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Z" />
  </BaseIcon>
);
